export default __webpack_public_path__ + "8953ec87b3ead2a15a2bc2249c228477.png";